import styled from "styled-components";
import { motion } from "framer-motion";

export const FeaturedStack = styled(motion.div)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

// A hard 1px rule with a centered roman numeral, separating featured quests.
// dell-1996 has no decorative dividers, only hairlines, so the numeral is the
// only ornament.
export const RomanDivider = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 26px 0;

  font-family: ${({ theme }) => theme.fonts.ui};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 3px;
  color: ${({ theme }) => theme.orange};

  &::before,
  &::after {
    content: "";
    width: 56px;
    height: 1px;
    background: ${({ theme }) => theme.orange};
    opacity: 0.5;
  }
`;
